export default {
  originsCategories: null,
};
